import { prop } from 'ramda';
import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledTimetableItem = styled.button<{
  $topPosition: number;
  $height: number;
  $width: number;
  $offsetX: number;
  $color?: string;
  $isMultiEvent?: boolean;
}>`
  position: absolute;
  height: calc(${prop('$height')}% - 0.1rem);
  top: ${prop('$topPosition')}%;
  left: calc(${prop('$offsetX')}% + (${tvar('space.half')} / 2));
  background: ${tvar('colors.fill.primary')};
  width: calc(${prop('$width')}% - ${tvar('space.half')});
  padding: ${tvar('space.half')};
  font-size: ${tvar('typographies.small.fontSize')};
  display: flex;
  flex-direction: column;
  cursor: pointer;
  box-shadow: none;
  text-align: left;
  border: 0;
  border-left: 0.2rem solid
    ${({ theme, $color, $isMultiEvent }) =>
      $isMultiEvent ? 'transparent' : $color || theme.colors.fill.inverted};

  @media (min-width: ${tvar('measures.breakpoints.tabletSm')}) {
    transition: all 0.1s ease-out;

    &:hover {
      z-index: 2;
      transform: translate(1px, -1px);
      box-shadow: 0px 1px 2px 0 rgba(0, 0, 0, 0.05);
    }
  }
`;

export const StyledTimetableItemTag = styled.div`
  text-decoration: underline;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  margin-bottom: ${tvar('space.half')};}
`;

export const StyledTimetableItemLabel = styled.div<{
  $moduleCount: number;
  $floating: boolean;
}>`
  text-overflow: ellipsis;
  ${({ $moduleCount }) => $moduleCount > 1 && 'white-space: pre;'}
  overflow: hidden;
  width: 100%;
  ${({ $floating }) =>
    $floating
      ? `
    position: absolute;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    top: 0;
    left: 0;
  `
      : ''};
`;

export const StyledMultiEventIndicators = styled.div`
  margin: ${tvar('space.half')} 0;
  flex-grow: 1;
  width: 100%;
  position: relative;
`;

export const StyledMultiEventIndicator = styled.div<{
  $topPosition: number;
  $height: number;
  $width: number;
  $offsetX: number;
  $color?: string;
}>`
  height: ${prop('$height')}%;
  width: calc(${prop('$width')}% - (${tvar('space.half')}));
  // width: min(0.25rem, calc(${prop('$width')}% / 3));
  border-radius: 0.1rem 0.1rem 0 0;
  top: ${tvar('space.half')};
  background-color: ${prop('$color')};
  opacity: 0.1;
  position: absolute;
  top: ${prop('$topPosition')}%;
  left: ${prop('$offsetX')}%;
  // left: calc(${prop('$offsetX')}% + (${prop('$width')}% / 3));
`;

export const StyledTimetableItemFooter = styled.div`
  text-overflow: ellipsis;
  white-space: pre-wrap;
  overflow: hidden;
  width: 100%;
  margin-top: auto;
  border-top: 0.1rem solid ${tvar('colors.neutrals.grey4')};
  padding-top: ${tvar('space.half')};
`;
